import {TradesQuotesFeed} from '../utils/WebsocketFeed'

angular.module('webtrader').service('Feed', function($rootScope, Account, $log) {
  this.init = () => {
    this.stream = new TradesQuotesFeed(WEBSOCKET_TORNADO_URL, Account.serverName, $log)
    this.stream.connect()
    $rootScope.$broadcast('feed:init')
  }

  this.deinit = () => {
    $rootScope.$broadcast('feed:deinit')
    this.stream.disconnect()
    delete this.stream
  }
})
